export const SERVER_API = 'http://test.heroforyou.space/api';
